(() => {
  'use strict';

  const path = '/pages/favorite-live-in-los-angeles';
  const data = {
    title: 'Favorite (Live In Los Angeles)',
    listen: 'https://seanflood.floodeverything.com/favorite-live-in-los-angeles-listen',
    youtubeId: '_UVXvRFi26Y',
    cover: 'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/19_fbac7e15-3190-433d-9468-0e8e7240bddf.png?v=1787425111',
    frames: [
      'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/1_94c29dee-1010-4ce8-b1e2-afa28f042c64.png?v=1787438507',
      'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/15_09d700a6-76e4-4950-93dc-6c3ed4ec2266.png?v=1787438478',
      'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/6_a85f556d-df67-4173-a519-298e3271cd38.png?v=1787438478',
      'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/13_069d6786-e644-45b3-bc70-45bb95a04bbe.png?v=1787438505',
      'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/19_2809a106-43cf-4bc9-9610-bd424f4fe992.png?v=1787438505',
      'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/16_94567efe-7633-4727-aeba-3462f8a4094d.png?v=1787438507'
    ]
  };

  const hydrate = () => {
    if (window.location.pathname.replace(/\/$/, '') !== path) return;
    const page = document.querySelector('.f-release-page');
    if (!page || page.dataset.favoriteLiveHydrated) return;
    page.dataset.favoriteLiveHydrated = 'true';

    const hero = page.querySelector('.f-release-hero');
    const oldCover = hero?.querySelector('.f-release-cover');
    if (oldCover) {
      const cover = document.createElement('a');
      cover.className = 'f-release-cover';
      cover.href = '#watch-film';
      cover.setAttribute('aria-label', `Watch ${data.title} film`);
      cover.innerHTML = `<img src="${data.cover}" alt="${data.title} cover art" loading="eager">`;
      oldCover.replaceWith(cover);
    }

    const actions = page.querySelector('.f-release-actions');
    const listen = actions?.querySelector('.f-release-button--filled');
    if (listen) listen.href = data.listen;
    if (actions && !actions.querySelector('a[href="#watch-film"]')) {
      const watch = document.createElement('a');
      watch.className = 'f-release-button';
      watch.href = '#watch-film';
      watch.textContent = 'Watch Film';
      const back = actions.querySelector('a[href="/pages/flood-sound"]');
      if (back) actions.insertBefore(watch, back);
      else actions.appendChild(watch);
    }

    const navSection = page.querySelector('.f-release-nav')?.closest('.f-release-section');
    if (!navSection) return;

    const watchSection = document.createElement('div');
    watchSection.className = 'f-release-section';
    watchSection.id = 'watch-film';
    watchSection.innerHTML = `<h2 class="f-release-section-title">Watch Film</h2><div class="f-release-video"><iframe src="https://www.youtube.com/embed/${data.youtubeId}?rel=0&modestbranding=1" title="${data.title} by Sean Flood" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe></div>`;

    const framesSection = document.createElement('div');
    framesSection.className = 'f-release-section';
    framesSection.innerHTML = `<h2 class="f-release-section-title">Selected Frames</h2><div class="f-release-frames">${data.frames.map((src, i) => `<button type="button" class="f-release-frame" data-release-lightbox-trigger data-index="${i}" aria-label="Expand ${data.title} selected frame ${i + 1}"><img src="${src}" alt="${data.title} selected frame ${i + 1}" loading="lazy"></button>`).join('')}</div><div class="f-release-lightbox" data-release-lightbox hidden role="dialog" aria-modal="true" aria-label="${data.title} selected frame viewer"><button type="button" class="f-release-lightbox__control f-release-lightbox__close" data-release-lightbox-close aria-label="Close image viewer">Close</button><button type="button" class="f-release-lightbox__control f-release-lightbox__arrow" data-release-lightbox-prev aria-label="Previous frame">←</button><div class="f-release-lightbox__stage" data-release-lightbox-stage><img class="f-release-lightbox__image" data-release-lightbox-image src="" alt=""></div><button type="button" class="f-release-lightbox__control f-release-lightbox__arrow" data-release-lightbox-next aria-label="Next frame">→</button></div>`;

    navSection.before(watchSection, framesSection);
    const navLeft = navSection.querySelector('.f-release-nav > div:first-child');
    if (navLeft) navLeft.innerHTML = '<a href="/pages/favorite">← Favorite</a>';

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    page.querySelectorAll('a[href="#watch-film"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        watchSection.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#watch-film');
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hydrate);
  else hydrate();
})();
